import { useContext, useEffect } from 'react';
import { DispatchEvent, State } from '../../../../../../library/Core/SmartTypes';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import PageBuilder from '../../../../../../library/Builders/PageBuilder/PageBuilder';
import EditDemographicssFormLayout from './EditDemographicssFormLayout';
import ProfileMarkerService from './ProfileMakerService';
import { allowPerformAction, displayActionNotAllowedAlert, isEmpty, isFormValid, setError } from '../../../../../../library/Core/SmartFunctions';
import Swal from 'sweetalert2';

const EditDemographicssModal = ({ userdata,DemographicsProps }: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { saveMarker,fetchUserProfileMarkers } = ProfileMarkerService();
    const handleSubmit = async (
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void
    ) => {
        event.preventDefault();
        if (!allowPerformAction()) {
            displayActionNotAllowedAlert();
            return;
        }
        const payload = {
            markerType: 'demographics',
            ...state?.data?.demographics,
        };

        //remove the keys having 'Analisis' suffix
        Object.keys(payload).forEach((k) => {
            if (k.endsWith('Analysis')) {
                console.log(k,'keys');
                delete payload[k];
            }
        });

        const visibleControl = state?.data?.visibleControl;
        let isSyncDataInvalid = false;
    
        if (['StudiedAbroad', 'CurrentlyAbroad', 'genderCode','LivedAbroadandBack'].includes(visibleControl)) {
            isSyncDataInvalid = validateSyncData(state, dispatch, DemographicsProps);
            console.log("validateSyncData", isSyncDataInvalid);
        }         
        if (!isFormValid(state, dispatch) || isSyncDataInvalid) {
            dispatch({ type: 'SHOW_ERRORS' });
            return;
        }
        
        await saveMarker({...payload,syncData : state?.data?.syncData?.[0] || {}}, state?.internal?.model?.id);
        await fetchUserProfileMarkers(state?.internal?.model?.id);
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showDemoGraphicsModal' } });
    };

    const validateSyncData = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void, DemographicsProps: any) => {
        const demographics = state?.data?.demographics || {};
        const syncData = state?.data?.syncData?.[0] || {};
        
        let isFormInvalid = false; // Start with no errors
    
        // Only check for the visibleControl key, if provided
        const visibleControl = state?.data?.visibleControl; // Assuming `visibleControl` is coming from state
    
        // List of keys to check
        const keysToCheck = ['StudiedAbroad', 'CurrentlyAbroad', 'genderCode','LivedAbroadandBack'];
    
        // If visibleControl exists, we only validate that field
        const keysToValidate = visibleControl && keysToCheck.includes(visibleControl) ? [visibleControl] : keysToCheck;
    
        // Loop through only the keys we need to check
        for (let key of keysToValidate) {
            const prop = DemographicsProps[key];
            if (prop && prop.isComment) {
                const commentField = prop.isComment as keyof typeof demographics;
                const demographicsValue = demographics[key] === undefined ? false : demographics[key];
                const syncDataValue = syncData[key] === undefined ? false : syncData[key];
    
                if (isFormInvalid) {
                    break;
                }
    
                if (key === 'genderCode' && demographicsValue !== syncDataValue && isEmpty(demographics[commentField])) {
                    isFormInvalid = true;
                    setError(
                        `demographics.${String(commentField)}`,
                        [`Please enter a comment for "${prop.label}" because the value has changed.`],
                        dispatch
                    );
                }
                else if ((key === 'StudiedAbroad' || key === 'CurrentlyAbroad' || key==='LivedAbroadandBack') && Boolean(demographicsValue) !== Boolean(syncDataValue) && isEmpty(demographics[commentField])) {
                    isFormInvalid = true;
                    setError(
                        `demographics.${String(commentField)}`,
                        [`Please enter a comment for "${prop.label}" because the value has changed.`],
                        dispatch
                    );
                }
                else if (Boolean(demographicsValue) === Boolean(syncDataValue)) {
                    setError(`demographics.${String(commentField)}`, [], dispatch);
                }
            }
    
            // If an error has been set, no need to check further keys
            if (isFormInvalid) {
                break;
            }
        }
        return isFormInvalid;
    };
    
    
    

    // const validateSyncData = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void, DemographicsProps: any) => {
    //     const demographics = state?.data?.demographics || {};
    //     console.log("demographics",demographics)
    //     const syncData = state?.data?.syncData?.[0] || {};
    //     console.log("syncData",syncData)
    //     let isFormInvalid = false;
    
    //     Object.keys(DemographicsProps).forEach((key) => {
    //         const demographicsKey = key as keyof typeof DemographicsProps;
    //         const prop = DemographicsProps[demographicsKey];
    
    //         if (prop.isComment) {
    //             const commentField = prop.isComment as keyof typeof demographics;
    //             // Validation for genderCode or other fields where the comment is required
    //             if (key === 'genderCode' && demographics[key] != syncData[key] 
    //                 && isEmpty(demographics[commentField])) 
    //                 {
    //                 isFormInvalid = true;
    //                 setError(
    //                     `demographics.${String(commentField)}`,
    //                     [`Please enter a comment for "${prop.label}" because the value has changed.`],
    //                     dispatch
    //                 );
    //             }
    //             else if((key === 'StudiedAbroad') && Boolean(demographics[key]) != Boolean(syncData[key]) &&
    //                 isEmpty(demographics[commentField]) 
    //             ) {                   
    //                 isFormInvalid = true;
    //                 setError(
    //                     `demographics.${String(commentField)}`,
    //                     [`Please enter a comment for "${prop.label}" because the value has changed.`],
    //                     dispatch
    //                 );
    //             }
    //             else {
    //                 isFormInvalid = false;
    //                 setError(`demographics.${String(commentField)}`, [], dispatch);
    //             }
    //         }
    //     });
    //     console.log("isFormInvalid",isFormInvalid)
    //     return isFormInvalid;
    // };
    

    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, SAVE: handleSubmit } });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <EditDemographicssFormLayout>{!state.flags.isDataLoading && <PageBuilder />}</EditDemographicssFormLayout>
        </SmartContext.Provider>
    );
};

export default EditDemographicssModal;
